import { version } from 'react';

const inertBooleanSupported = Number(version.split('.')[0]) >= 19;

/**
 * Allows proper value usage for react 18 / 19 inert property. `inert` is not in the
 * react 18 types for the HTMLAttributes and is treated differently.
 * @see https://stackoverflow.com/a/78606437/2143311
 * @see https://github.com/facebook/react/issues/17157
 * @internal
 */
// oxlint-disable-next-line typescript/no-explicit-any
export function getProperInertValue(inert: boolean): any {
  if (inertBooleanSupported) {
    return inert;
  }
  return inert ? '' : undefined;
}
